import appStore from 'store';
import api from './api';
import LANGUAGE from 'common/languages_code';

const store = {
    namespaced: true,
    state: {
        posterList: [],
        detailDialogVisible: false,
        query: {language: String(Object.keys(LANGUAGE)[0])},
        posterDetail: {},
        languageList: Object.keys(LANGUAGE).map(item => {
            return {
                value: String(item),
                label: LANGUAGE[item]
            };
        })
    },
    getters: {
        posterList: state =>
            state.posterList
                .map(item => {
                    return {
                        ...item
                    };
                }),
        posterDetail: state => state.posterDetail
    },
    mutations: {
        setPosterList(state, payload) {
            state.posterList = payload.slice();
        },
        toggleDetailDialogVisible(state, payload) {
            state.detailDialogVisible = payload;
        },
        setPosterDetail(state, payload) {
            state.posterDetail = Object.assign({}, payload);
        },
        changeQuery(state, payload) {
            state.query = payload;
        }
    },
    actions: {
        list({commit}, query) {
            api.getInvitePosterList(query).then(({data}) => {
                commit('setPosterList', data.data);
            });
        },
        setDetail({commit}, data) {
            commit('setPosterDetail', data);
        },
        create({commit}, poster) { // eslint-disable-line
            return new Promise(resolve => {
                api.createInvitePoster(poster).then(res => {
                    resolve(res);
                });
            });
        },
        update({commit}, {createTime, ...poster}) { // eslint-disable-line
            return new Promise(resolve => {
                api.updateInvitePoster(poster).then(res => {
                    resolve(res);
                });
            });
        },
        remove({commit}, id) { // eslint-disable-line
            return new Promise(resolve => {
                api.removeInvitePoster(id).then(res => {
                    resolve(res);
                });
            });
        }
    }
};

appStore.registerModule('posterSetting', store);
